import { Talent, User } from "../../../types/user";
import "./../TalentInfo/TalentInfo.scss";
import { Icons } from "../../assets/icon";
import { Button, useTheme, useMediaQuery, Stack } from "@mui/material";

// —— Netflix-ish tokens (visual only)
const COLORS = {
  bg: "#0b0b0b",
  panel: "#141414",
  text: "#ffffff",
  muted: "rgba(255,255,255,0.75)",
  border: "rgba(255,255,255,0.12)",
  red: "#E50914",
};

export default function TalentInfo({
  talentInfo,
  userInfo,
}: {
  talentInfo: Talent;
  userInfo: User;
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <div
      className="talent-info-container"
      style={{
        borderBottom: `1px solid ${COLORS.border}`,
        paddingBottom: "16px",
        color: COLORS.text,
      }}
    >
      <div
        className="talent-info-wrapper"
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          alignItems: isMobile ? "center" : "flex-start",
          gap: isMobile ? "16px" : "24px",
          marginBottom: isMobile ? "16px" : "0",
        }}
      >
        <img
          src={talentInfo?.profile_image ?? "/assets/Upstream.png"}
          alt="profile-image"
          style={{
            width: isMobile ? "80px" : "100px",
            height: isMobile ? "80px" : "100px",
            borderRadius: "50%",
            objectFit: "cover",
          }}
        />
        <div
          className="info-section"
          style={{
            textAlign: isMobile ? "center" : "left",
          }}
        >
          <div
            className="username"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              alignItems: isMobile ? "center" : "flex-start",
            }}
          >
            <h2
              style={{
                fontSize: isMobile ? "1.25rem" : "1.5rem",
                margin: 0,
                color: COLORS.text,
              }}
            >
              {`${userInfo?.first_name} ${userInfo?.last_name}`}
            </h2>
            <span
              style={{
                fontSize: isMobile ? "0.875rem" : "1rem",
                color: COLORS.muted,
              }}
            >
              @{talentInfo.username}
            </span>
          </div>
        </div>
      </div>
      <Stack
        direction={isMobile ? "column" : "row"}
        spacing={2}
        sx={{
          width: "100%",
          justifyContent: isMobile ? "center" : "flex-end",
          alignItems: "center",
        }}
      >
        <button
          className="edit-profile-button"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            padding: isMobile ? "8px 16px" : "10px 20px",
            fontSize: isMobile ? "0.875rem" : "1rem",
            width: isMobile ? "100%" : "auto",
            backgroundColor: "rgba(255,255,255,0.06)",
            border: `1px solid ${COLORS.border}`,
            borderRadius: "8px",
            color: COLORS.text,
            cursor: "pointer",
          }}
        >
          <Icons.ShareIcon
            height={isMobile ? 16 : 20}
            width={isMobile ? 16 : 20}
          />
          Share Profile
        </button>
        <Button
          onClick={() => {}}
          color="primary"
          variant="contained"
          sx={{
            background: COLORS.red,
            color: COLORS.text,
            fontWeight: 500,
            fontSize: isMobile ? "0.875rem" : "14px",
            textTransform: "none",
            borderRadius: "8px",
            px: isMobile ? 1 : 2,
            py: isMobile ? 1 : 1.5,
            width: isMobile ? "100%" : "fit-content",
            height: "fit-content",
            "&:hover": {
              background: "#b20710",
            },
          }}
        >
          View Public Profile
        </Button>
      </Stack>
    </div>
  );
}
